module.exports = __webpack_public_path__ + "static/img/mf.5b9ff36c.svg";